<template>
  <!--<transition name="el-zoom-in-center">-->
  <div>
    <div class="feedback"> <el-tooltip class="item" effect="dark" :content="$t('common.feedback')" placement="top-start">
      <i class="el-icon-edit-outline feedback-btn" @click="dialogVisible = true"></i>
    </el-tooltip></div>
    
    <el-dialog :title="$t('common.feedback')" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <div>
        <i class=""></i>
        <!-- {{ $t('points.reminder') }}：{{ $t('common.feedbackTips') }} -->
      </div>      
      <el-input type="textarea" :rows="6" :placeholder="$t('common.feedbackChatTip')" maxlength="500" show-word-limit v-model="textarea"></el-input>
      <!-- 联系方式 -->
      <div style="margin-top: 16px;">
        {{ $t('user.Contact') }}：<el-input style="width: 360px;" v-model="textarea2" :placeholder="$t('common.reply')"></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submit" :loading="flag">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postFeedback } from '@/api/feedback';
export default {
  name: 'feedback',
  data() {
    return {
      dialogVisible: false,
      textarea: '',
      textarea2: '',
      userId: '',
      flag: false
    };
  },

  methods: {
    submit() {
      // if (this.$store.state.token == '') {
      //   this.$message({ message: this.$t('login.loginTip'), type: 'warning', showClose: true });
      //   let that = this;
      //   setTimeout(function() {
      //     that.$router.push({ path: '/login' });
      //   }, 500);
      //   return;
      // }
      if (this.textarea.trim() == '') {
        this.$message({ message: this.$t('msg.sendMsgTip'), type: 'warning', showClose: true });
        return;
      }
      this.flag = true;
      let updataObj = {
        content: this.textarea,
        contact: this.textarea2,
        userId: this.$store.state.id
      };
      postFeedback(updataObj).then(res => {
        this.flag = false;
        if (res.code == 0) {
          this.$message({
            message: this.$t('common.successTip'),
            type: 'success',
            showClose: true
          });
          this.dialogVisible = false;
          this.textarea = '';
          this.textarea2 = '';
        } else {
          this.$message({
            message: this.$t('common.networkException'),
            type: 'error',
            showClose: true
          });
        }
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.feedback-btn {
  color: #0e1724;
  display: block;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
}
.feedback {
  background-color: #fff;
  position: fixed;
  right: 40px;
  bottom: 200px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  -webkit-box-shadow: 0 0 6px rgb(0 0 0 / 12%);
  box-shadow: 0 0 6px rgb(0 0 0 / 12%);
  z-index: 5;
}

.feedback-btn:hover {
  color: #135bff;
}
</style>



// WEBPACK FOOTER //
// src/components/feedback/feedback.vue